<h6 class="center">{{ qualification.qualification_name }}</h6>
<div class="clearfix"></div>
<ng-container *ngIf="qualification?.data?.length">
  <div class="row">
    <div class="col-md-12">
      <button
        *ngIf="quotaFlags.census"
        type="button"
        class="btn btn-default btn-link btn-xs add-quotas"
        id="{{ qualification.qualification_code }}-add-cencus-quota"
        (click)="applySelectLocationCensus()"
        [disabled]="qualification.isAdvanceTargetingParent || isQlcLiveSurvey"
      >
        Add Census Quotas
      </button>
      <button
        *ngIf="quotaFlags.add"
        type="button"
        id="{{ qualification.qualification_code }}-add-custom-quota"
        class="btn btn-default btn-link btn-xs add-quotas"
        (click)="openSelectLocationQuotaModal()"
        [disabled]="qualification.isAdvanceTargetingParent || isQlcLiveSurvey"
      >
        Add Custom Quotas
      </button>
      <button
        *ngIf="quotaFlags.edit"
        type="button"
        class="btn btn-default btn-link btn-xs add-quotas"
        (click)="openSelectLocationQuotaModal()"
        id="{{ qualification.qualification_code }}-edit-quota"
      >
        Edit Quotas
      </button>
      <button
        *ngIf="quotaFlags.delete"
        type="button"
        class="btn btn-default btn-link btn-xs add-quotas"
        (click)="deleteSelectLocationQuotas()"
        [disabled]="isQlcLiveSurvey"
      >
        Delete Quotas
      </button>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12">
      <div class="box-container" *ngFor="let option of qualification.data">
        <div
          class="box"
          [ngClass]="{ 'div-disabled': qualification.isAdvanceTargetingParent }"
          [class.selected]="option.selected"
          (click)="changeOption(option)"
        >
          <label>{{ option.text }}</label>
        </div>
        <span>{{ option.sub_text }}</span>
      </div>
    </div>
  </div>
</ng-container>
